import React from "react"
import GlobalStateProvider from "./src/global/global"

export const wrapPageElement = ({ element, props }) => {
  return <GlobalStateProvider {...props}>{element}</GlobalStateProvider>
}
